var $ed9b4bf7ce1fb1d7$exports = {};
$ed9b4bf7ce1fb1d7$exports = {
  "removeButtonLabel": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
  "removeDescription": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 DELETE, \u0447\u0442\u043E\u0431\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0435\u0433."
};
export { $ed9b4bf7ce1fb1d7$exports as default };